import { useEffect, useRef } from 'react';

/**
 * Hook that manages event subscriptions and automatically cleans them up
 * @param {Array} subscriptions - Array of subscription functions that return unsubscribe functions
 */
export const useSubscription = (subscriptions = []) => {
  const subscribersRef = useRef([]);

  useEffect(() => {
    subscribersRef.current = subscriptions;

    return () => {
      subscribersRef.current.forEach((unsubscribe) => {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      });
    };
  }, [subscriptions]);
};

